module.exports = __webpack_public_path__ + "img/HeimwehScreenshot04.ba480a89.png";